module.exports = __webpack_public_path__ + "media/components/home/unlock-vecteezy/img/find-your-path-mobile-vector-d4836ad9b2522ef05444afe3a55d3338.jpg";